import { globalContext } from 'context/global';
import { useContextSelector } from 'use-context-selector';

export function useGlobalStatistics() {
  const statistics = useContextSelector(
    globalContext,
    context => context.statistics
  );

  const loadStatistics = useContextSelector(
    globalContext,
    context => context.loadStatistics
  );

  const handleClearStatistics = useContextSelector(
    globalContext,
    context => context.handleClearStatistics
  );

  return {
    statistics,
    loadStatistics,
    handleClearStatistics,
  };
}
